module.exports = __webpack_public_path__ + "static/analytics-1-72a5a7dd28e15de6136b167efa7d21bf.jpg";